module.exports = __webpack_public_path__ + "static/media/sms.a6b3d619.jpg";